import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import ReceiptCheckIcon from 'src/icons/untitled-ui/duocolor/receipt-check';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import Tool02Icon from 'src/icons/untitled-ui/free/tool-02';
import TicketIcon from 'src/icons/untitled-ui/free/ticket';

export const censorSections = (t, tokens, paths, SvgIcon) => {
  return [
    {
      items: [
        {
          title: t(tokens.nav.overview),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.tms),
          path: paths.tms.index,
          icon: (
            <SvgIcon fontSize="small">
              <AccessTimeOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.fuel),
          path: paths.fuels.index,
          icon: (
            <SvgIcon fontSize="small">
              <ReceiptCheckIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.repair),
          path: paths.repairs.index,
          icon: (
            <SvgIcon fontSize="small">
              <Tool02Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.tickets),
          path: paths.tickets.index,
          icon: (
            <SvgIcon fontSize="small">
              <TicketIcon />
            </SvgIcon>
          ),
        },
      ],
    },
  ];
};
